import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Advice, defense and disputes — Lawyers in Mechelen"}
                    description={"Administrative law, civil service, business, taxation, civil and criminal law — we advise and defend individuals and companies"}
                    url={"https://www.coeladvocaten.be/en/advice-defense-disputes"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/advies-verdediging-geschillen", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/conseils-defense-litiges", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/advice-defense-disputes", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/advies-verdediging-geschillen"
                    switchUrlFR="/fr/conseils-defense-litiges"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-conseils-defense-litiges"></div>
                        <div className="slider">
                            <h1>Our services</h1>
                            <h2>Advice, defense and disputes</h2>
                            <p></p>
                            <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Our lawyers bring you their expertise to advise you and defend your interests in the following areas.</p>
                                            <p><b>Administrative law and civil service law</b></p>
                                            <p><b>Defense of individuals and companies against decisions of administrative authorities, at any level, from the arbitrary procedure for revision to the cancellation of decisions by the Council of State</b></p>
                                            <p>- Disputes with administrations: refusal or revocation of authorizations or licenses, refusal of marriage or entry into the territory, etc. </p>
                                            <p>- Disputes concerning appointment and dismissal procedures for statutory and contractual personnel</p>
                                            <p><b>Company law</b></p>
                                            <p>Advice and defense in all matters relating to company life: </p>
                                            <p>- Startups and business creation: feasibility studies and forecasts, choice of business form, preparation of a financial plan, registration with the social insurance fund, CBE (Crossroads Bank for Enterprises) registration, VAT number activation, optimization of social security contributions and income, etc.</p>
                                            <p>- Disputes between partners</p>
                                            <p>- Mergers and acquisitions</p>
                                            <p>- Reorganizations, liquidations and bankruptcies</p>
                                            <p><b>Tax law</b></p>
                                            <p>Advice and defense of individuals and companies</p>
                                            <p>- Personal and business taxation: personal income tax, corporate tax, legal entity tax, non-resident taxation, VAT, etc.</p>
                                            <p>- Registration duties and mortgages</p>
                                            <p>- Inheritance tax and national and international estate planning</p>
                                            <p>- Regional and local taxes</p>
                                            <p>- European and international tax law</p>
                                            <p>- Tax procedure</p>
                                            <p>- Requests for advance decisions, at the Flemish regional and federal levels</p>
                                            <p>- Management companies and property companies</p>
                                            <p>- Cross-border taxation and double taxation avoidance agreements</p>
                                            <p>- Purchase of second homes abroad (including Spain)</p>
                                            <p><b>Civil law</b></p>
                                            <p>Advice and defense of individuals and companies, particularly in matters of commercial leases and agricultural law:</p>
                                            <p>- Easements</p>
                                            <p>- Land leases and farm leases</p>
                                            <p>- Rent and commercial rent</p>
                                            <p>- Expropriations</p>
                                            <p><b>Criminal law</b></p>
                                            <p>Defense of individuals and companies for all criminal matters: police court, court of first instance and up to the Court of Cassation, as defendant and civil party.</p>
                                            <p><b>Need advice or defense?</b></p>
                                            <p><br /></p>
                                            <p className="text-center"><a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /><br /></div>
                        </div>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
